import {
    createRouter,
    createWebHistory
} from "vue-router";
import Main from "@/views/Main.vue";
import Project from "@/views/Project.vue";
import Story from "@/views/Story.vue";
import Accolades from "@/views/Accolades/Accolades.vue";
import Accolade from "@/views/Accolades/Accolade.vue"

const routes = [
    {
        path: "/",
        name: "Main",
        component: Main,
        meta: {
            profileContent: {
                content: "Main",
                backgroundImage: ""
            }
        }
    },
    {
        path: "/project/:name",
        name: "Project",
        component: Project,
        meta: {
            id: -1,
            timelineProjectMapID: -1
        }
    },
    {
        path: "/story",
        name: "Story",
        component: Story
    },
    {
        path: "/accolades",
        name: "Accolades",
        component: Accolades
    },
    {
        path: "/accolade/:accoladeID",
        name: "Accolade",
        component: Accolade
    }
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
});

export default router;